const AUTH_REQUEST_URL = 'https://t56nd5thkk.execute-api.ap-northeast-1.amazonaws.com/v1/auth_request';
const AUTH_RESULT_URL = 'https://t56nd5thkk.execute-api.ap-northeast-1.amazonaws.com/v1/auth_result';
const COMPANY_TOKEN = '0InzU6IqZsKEkohvkmR6jhCa5xL5KfdF';
// const COMPANY_TOKEN = 't7m34nzxrgddz373ix2iz3ikzakbhg3j';
const CALL_TELNO = '05036139685';
// const CALL_TELNO = '0120810377';
const CONTDOWN_TIMER = 60;
const phoneText = document.getElementById('phoneText');
phoneText.innerHTML = `<a class="text-lg text-bold" href="tel:${CALL_TELNO}">${CALL_TELNO.replace(/^(\d{3})(\d{4})(\d{4})$/, "$1-$2-$3")}</a>`;

let pollingInterval = null;
let startTime = null;

const formRegister = document.getElementById('formRegister');
const formLogin = document.getElementById('formLogin');
const formInfront = document.getElementById('formInfront');
const telInput = document.getElementById('RegisterForm-phone');
const hiddenTelInput = document.querySelector('input[name="customer[note]"]');

const statusText = document.getElementById('statusText');
const errorsText = document.getElementById('errorsText');
const timeText = document.getElementById('timeText');
const processText = document.getElementById('processText');
const processErrors = document.getElementById('processErrors');
const startButton = document.getElementById('startButton');
const cancelButton = document.getElementById('cancelButton');
const submitButton = document.getElementById('submitButton');

let currentStep = 0;
function updateStepper(step) {
  const steps = document.querySelectorAll('#stepper .step');
  const contents = document.querySelectorAll('[class^="display-step-"]');

  currentStep = step;

  steps.forEach((stepEl, index) => {
    stepEl.classList.remove('active', 'done');
    if (index < currentStep) {
      stepEl.classList.add('done');
    } else if (index === currentStep) {
      stepEl.classList.add('active');
    }
  });

  contents.forEach(content => {
    content.style.display = 'none';
  });
  document.querySelectorAll(`.display-step-${currentStep}`).forEach(el => {
    el.style.display = 'block';
  })
}

updateStepper(0);

function getResultMessage(result) {
  switch (result) {
    case '0': return '正常';
    case '9': return '異常';
    default: return `未知のステータス(${result})`;
  }
}

function getAuthRequestDetailMessage(detail) {
  switch (detail) {
    case '00': return 'FP認証完了';
    case '01': return '電話番号認証';
    case '11': return '企業コードが存在しないエラー';
    case '12': return '有効期限が切れているエラー';
    case '13': return 'パラメータエラー';
    case '14': return 'サービス停止中エラー';
    case '15': return '既に認証依頼中エラー';
    case '16': return '輻輳エラー';
    case '99': return '想定外エラー';
    default: return `未知の値(${detail})`;
  }
}

function getAuthResultDetailMessage(detail) {
  switch (detail) {
    case '00': return '認証中';
    case '01': return '認証結果OK';
    case '02': return 'タイムアウトエラー';
    case '11': return '企業コードが存在しないエラー';
    case '12': return '有効期限が切れているエラー';
    case '13': return 'パラメータエラー';
    case '14': return 'サービス停止中エラー';
    case '16': return '輻輳エラー';
    case '18': return '認証依頼なし（電話番号なし）';
    case '99': return '想定外エラー';
    default: return `未知の値(${detail})`;
  }
}

function startPolling(conv_telno) {
    if (pollingInterval) return;
    
    let countdown = CONTDOWN_TIMER;
    if(processErrors) {
      processErrors.style.display = 'none';
    }

    pollingInterval = setInterval(async () => {
    if(timeText) {
      timeText.textContent = countdown;
    }
    if (countdown <= 0) {
      if(processErrors) {
        processErrors.style.display = 'block';
      }
      stopPolling();
      return;
    }
    countdown--;

    try {
      const response = await fetch(AUTH_RESULT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ company_token: COMPANY_TOKEN, conv_telno: conv_telno }),
      });
      const data = await response.json();
      const detailMessage = getAuthResultDetailMessage(data.detail);
      const resultMessage = getResultMessage(data.result);
      if(statusText) {
        statusText.innerText = `${detailMessage}`;
      }
      
      if (data.result === '0' && data.detail === '01') {
        console.log('処理完了！ポーリング停止');
        verifySuccess();
      } else if (data.result === '0' && data.detail === '02') {
        console.log('タイムアウト！ポーリング停止');
      }

    } catch (e) {
      console.error('ポーリングエラー:', e);
      stopPolling();
    }
  }, 1000);

  cancelButton.disabled = false;
  startButton.disabled = true;
  if(processText) {
    processText.style.display = 'block';
  }
}

function stopPolling() {
    updateStepper(0);
    if(pollingInterval) {
        clearInterval(pollingInterval);
        pollingInterval = null;
        cancelButton.disabled = true;
        startButton.disabled = false;
        if(processText) {
          processText.style.display = 'none';
        }
    }
}

function verifySuccess () {
  if(formInfront) {
    formInfront.remove();
  }
  if(formRegister) {
    formRegister.style.display = 'block';
  }
  if(formLogin) {
    formLogin.style.display = 'block';
  }
  hiddenTelInput.value = telInput.value;
  stopPolling();
  updateStepper(2);
}


startButton.addEventListener('click', async (e) => {
  e.preventDefault();
  const tel = telInput.value.trim();
  if (!tel.match(/^\d{10,11}$/)) {
    if(errorsText) {
      errorsText.innerHTML = `電話番号を正しく入力してください`;
    }
    return;
  }

  if(statusText) {
    statusText.textContent = '認証リクエスト送信中...';
  }
  startTime = Date.now();
  try {
    const response = await fetch(AUTH_REQUEST_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        company_token: COMPANY_TOKEN,
        callee_telno: tel,
      }),
    });

    const data = await response.json();
    const detailMessage = getAuthRequestDetailMessage(data.detail);
    if(statusText) {
      statusText.innerText = `${detailMessage}`;
    }
    if (data.result == '0') {
      updateStepper(1);
      startPolling(data.telno);
    } else {
      startButton.disabled = false;
    }
  } catch (error) {
    if(statusText) {
      statusText.textContent = '認証リクエスト失敗';
    }
    console.error(error);
  }
});

cancelButton.addEventListener('click', async () => {
  stopPolling();
});


